/**
 * 工作人员
**/

import {http} from '@/server/meetHttpServer.js'

// 庭审数量
export const getMeetingCount = (data) => {
    return http({ url:'/pisces/meeting/getMeetingCount'}, data)
}

// 庭审列表
export const getMeetingList = (data) => {
    return http({ url:'/pisces/meeting/getMeetingList'}, data)
}

// 新建调解室
export const addMediationRoom = (data) => {
    return http({ url:'/pisces/mediationRoom/addMediationRoom'}, data)
}
// 预约庭审
export const addMeeting = (data) => {
    return http({ url:'/pisces/meeting/addMeeting'}, data)
}
// 获取调解室用户信息列表
export const getMediationRoomUserInfoList = (data) => {
    return http({ url:'/gzzc/room/getMediationRoomUserInfoList'}, data)
}
// 关闭调解室
export const closeMediationRoom = (data) => {
    return http({ url:'/pisces/mediationRoom/closeMediationRoom'}, data)
}
// 添加调解室用户
export const addMediationRoomUser = (data) => {
    return http({ url:'/pisces/mediationRoom/addMediationRoomUser'}, data)
}
// 进入调解室
export const intoMediationRoom = (data) => {
    return http({ url:'/gzzc/room/intoMediationRoom'}, data)
}
// 查询单聊记录
export const oneToOneMsg = (data) => {
    return http({ url:'/gzzc/room/oneToOneMsg'}, data)
}
// 查询聊天记录
export const roomMsg = (data) => {
    return http({ url:'/gzzc/room/roomMsg'}, data)
}
// 角色列表
export const listBackstageUser = (data) => {
    return http({url: '/pisces/backstageUser/listBackstageUser', method: 'post'}, data)
}
// 案件空间内添加联系人
export const addMediationRoomUserMicro = (data) => {
    return http({url: '/pisces/mediationRoom/addMediationRoomUser',method: 'post'}, data)
}
// 获取案件用户信息列表
export const getMediationRoomUserInfoAllList = (data) => {
    return http({url: '/pisces/mediationRoom/getMediationRoomUserInfoList',method: 'post'}, data)
}
// 语音token
export const getVoiceRecogKey = (data) => {
    return http({url: '/pisces/voiceRecog/getVoiceRecogKey',method: 'post'}, data)
}

// 视频记录
export const getVideoList = (data) => {
    return http({url: '/pisces/meeting/getVideoList',method: 'post'}, data)
}

// 案由
export const getCauseList = (data) => {
    return http({url: '/pisces/cause/getCauseList',method: 'post'}, data)
}

// 获取案件空间里的用户头像接口
export const getHeadPortraitUrlList = (data) => {
    return http({url: '/gzzc/room/getHeadPortraitUrlList',method: 'post'}, data)
}

// 编辑未开始的庭审
export const editMeeting = (data) => {
    return http({url: 'pisces/meeting/editMeeting',method: 'post'}, data)
}
// 编辑案件（调解室
export const editMediationRoom = (data) => {
    return http({url: 'pisces/mediationRoom/editMediationRoom',method: 'post'}, data)
}

// 复制证据和文书
export const copyAttachment = (data) => {
    return http({url: 'pisces/meeting/copyAttachment',method: 'post'}, data)
}

// 获取案件信息
export const caseInfoApi = data =>
     http({url: '/scavenger/trial/meetingDetail',method: 'post'}, data)

// 异步庭审邀请人员
export const addMeetingPerson = data =>
     http({url: '/gzzc/trial/addMeetingPerson',method: 'post'}, data)

//  修改笔录中名称
export const updateRecordName = data =>
     http({url: '/gzzc/trial/updateUserRecordName',method: 'post'}, data)

//  修改手机号和身份证号
export const updateUserCardAndPhone = data =>
    http({url: '/gzzc/trial/updateUserCardAndPhone',method: 'post'}, data)

//  修改代理对象
export const modifyAgentInfo = data =>
http({url: '/gzzc/trial/modifyAgentInfo',method: 'post'}, data)

//  控制当事人和代理人上传证据
export const updateUserCanUpload = data =>
http({url: '/gzzc/trial/updateUserCanUpload',method: 'post'}, data)

//  修改仲裁请求
export const updateRequestItem = data =>
    http({url: '/gzzc/trial/updateRequestItem',method: 'post'}, data)

// 生成文书 调解模式
export const createDocxMediation = (data) => {
    return http({url:'/scavenger/docxMediation/createDocxMediation'}, data)
}

// 生成文书 撤诉模式
export const generateDoc = (data) => {
    return http({url:'/scavenger/mediation/generateDoc'}, data)
}

// 生成文书 发送文书
export const sendDoc = (data, mode) => {
    return http({url:`/scavenger/mediation/sendDoc/${mode}`}, data)
}

// 获取当事人预留签名 + 邮箱地址
export const getUserSingnatureAndEmail = (data) => {
    return http({ url: '/scavenger/mediation/getUserSingnatureAndEmail', method: 'get'}, data)
}

// 工作人员修改邮箱地址
export const setUserEmail = (data) => {
    return http({ url: '/scavenger/user/setUserEmail' }, data)
}

// 异步调解 查看文书列表
export const signDocList = (data) => {
    return http({ url: '/scavenger/mediation/signDocList', method: 'get' }, data)
}

// 异步调解 删除文书
export const delDocAndAttach = (data) => {
    return http({ url: '/scavenger/mediation/delDocAndAttach' }, data)
}

// 异步调解 文书列表中发送文书
export const sendAsyncMediationDoc = (data) => {
    return http({ url: '/scavenger/mediation/sendAsyncMediationDoc' }, data)
}

// 异步调解 补发接口
export const manualSendStampDoc = (data) => {
    return http({ url: '/scavenger/mediation/manualSendStampDoc' }, data)
}

// 在线送达 补发接口
export const manualSendDeliveryDoc = (data) => {
    return http({ url: '/scavenger/onlineDelivery/manualSendDeliveryDoc' }, data)
}

// 在线送达文书 查看文书列表
export const onlineDocList = (data) => {
    return http({url: '/scavenger/onlineDelivery/onlineDocList', method: 'get'}, data)
}

// 在线送达文书  预览送达回证
export const sendPreview = (data) => {
    return http({ url: '/scavenger/onlineDelivery/sendPreview' }, data)
}

// 在线送达文书  发送文书
export const sendOnlineDoc = (data) => {
    return http({ url: '/scavenger/onlineDelivery/sendOnlineDoc' }, data)
}

// 上传附件
export const gzzcUpLoadDoc = (data) => {
    return http({ url: '/gzzc/trial/gzzcUpLoadDoc' }, data)
}

// 创建快速案件
export const addCaseMeeting = data => {
    return http({url: '/gzzc/trial/addMeeting',method: 'post'}, data)
}

// 普通用户获取盖章版文书列表
export const documentList = data => {
    return http({url: '/scavenger/docxMediation/documentList',method: 'post'}, data)
}

// 普通用户获取送达文书列表
export const getUserOnlineDocList = data => {
    return http({url: '/scavenger/onlineDelivery/getUserOnlineDocList',method: 'get'}, data)
}

// 上传送达回证
export const uploadRevision = data => {
    return http({url: '/scavenger/onlineDelivery/uploadRevision',method: 'post'}, data)
}

// 普通用户获取附件列表
export const queryOtherDocList = data => {
    return http({url: `/gzzc/docBook/queryOtherDocList?meetingId=${data}`,method: 'get'})
}
